'use strict';
const goldAssetType = 'gold-asset',
	goldAssetPrefix = goldAssetType + ':',
	isUploadableImage = require('./is-uploadable-image'),
	isUploadableAttachment = require('./is-uploadable-attachment'),
	isGoldAssetId = function (resourceId) {
		return resourceId && resourceId.indexOf(goldAssetPrefix) === 0 && resourceId.length > goldAssetPrefix.length;
	},
	isGoldAssetMetadata = function (metadata) {
		if (!metadata || metadata.type !== goldAssetType || !metadata.fileId  || !metadata.assetId) {
			return false;
		}
		return metadata;
	},
	resourceIdFromAssetId = function (assetId) {
		return !!assetId && goldAssetPrefix + assetId;
	},
	assetIdFromResourceId = function (resourceId) {
		if (!resourceId) {
			return false;
		}
		return isGoldAssetId(resourceId) && resourceId.slice(goldAssetPrefix.length);
	},
	metadataForGoldAsset = function (resourceId, fileId, contentUrl) {
		if (!isGoldAssetId(resourceId)) {
			return false;
		}
		if (!fileId) {
			throw 'invalid-args';
		}
		const result = {
			type: goldAssetType,
			fileId: fileId,
			assetId: assetIdFromResourceId(resourceId)
		};
		if (contentUrl) {
			result.contentUrl = contentUrl;
		}
		return result;
	},
	assetIdFromIcon = function (idea) {
		return idea && idea.attr && idea.attr.icon && assetIdFromResourceId(idea.attr.icon.url);
	},
	assetIdFromAttachment = function (idea) {
		return idea && idea.attr && idea.attr.attachment && idea.attr.attachment.goldAssetId && assetIdFromResourceId(idea.attr.attachment.goldAssetId);
	},
	resourceIdToUrlMap = function (assetIdToUrlMap) {
		const result = {};
		Object.keys(assetIdToUrlMap).forEach(function (key) {
			result[resourceIdFromAssetId(key)] = assetIdToUrlMap[key];
		});
		return result;
	},
	getUploadableImage = function (idea) {
		const icon = idea.attr && idea.attr.icon,
			imageUrl = icon && icon.url;
		return imageUrl && isUploadableImage(imageUrl) && icon;
	},
	getUploadableAttachment = (idea) => {
		const attachment = idea.attr && idea.attr.attachment,
			attachmentUrl = attachment && attachment.dataUriEncoded && attachment.content;
		return attachmentUrl && isUploadableAttachment(attachmentUrl) && attachment;
	},
	replaceAttachmentWithResourceId = (activeContent, ideaId, resourceId, attachmentMetadata) => {
		if (!activeContent || !ideaId) {
			throw new Error('invalid-args');
		}
		if (!resourceId) {
			return;
		}
		const updated = Object.assign({}, attachmentMetadata);
		delete updated.content;
		delete updated.dataUriEncoded;
		updated.goldAssetId = resourceId;

		activeContent.updateAttr(ideaId, 'attachment', updated);
	},
	replaceImageWithResourceId = (activeContent, ideaId, resourceId) => {
		if (!activeContent || !ideaId) {
			throw new Error('invalid-args');
		}
		if (!resourceId) {
			return;
		}
		activeContent.mergeAttrProperty(ideaId, 'icon', 'url', resourceId);

	};

module.exports = {
	assetIdFromIcon, assetIdFromAttachment, assetIdFromResourceId,
	getUploadableAttachment, getUploadableImage, goldAssetType, goldAssetPrefix, isGoldAssetId, isGoldAssetMetadata, metadataForGoldAsset, replaceAttachmentWithResourceId, replaceImageWithResourceId, resourceIdFromAssetId, resourceIdToUrlMap
};

